import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IMyOptions } from 'ng-uikit-pro-standard';
// tables
import { Component, OnInit, ElementRef, HostListener, AfterViewInit, ViewChild, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'ng-uikit-pro-standard';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
declare var $: any;
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { MapInformationService } from 'src/app/services/map-information.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'alarm-customers',
  templateUrl: './alarm-customers.component.html',
  styleUrls: ['./alarm-customers.component.scss']
})
export class AlarmCustomersComponent implements OnInit {
  @Input() PopupAlarm: any;
  @Output() CerrarModal = new EventEmitter<any>();

  PhasesAlarm: any[] = []
  customOperations: Array<any>;
  popupPosition: any;
  TotalAlarms:number=0
  dateFormat1:any

  constructor(
    private customerService: CustomerService,
    private generalService: GeneralService,
    public fb: FormBuilder,
    private router: Router,
    private toast: ToastService,
    public MapInformationService:MapInformationService,
    public appConfigService: AppConfigService,
    private translate:TranslateService) {
    this.dateFormat1 = this.appConfigService.dateFormat
    // this.customerSelecte = null;
    /**
     * Init form new custumer vars
     */
  }

  ngOnInit() {
    console.log("dsfsdfs")
    this.getAlarms()
  }

  getAlarms() {
    const data = {
      method: "Get_CustomertWorkFlowAlarms"
    }
    this.MapInformationService.SaveInfoSites(data)
      .subscribe(resp => {
        console.log(resp)
        this.TotalAlarms = resp.length
        this.PhasesAlarm = resp
      })
  }

  OpenPopupAlarm() {
    this.PopupAlarm = true
  }

  ClosePopupAlarm() {
    this.PopupAlarm = false
    this.CerrarModal.emit(false)
  }

  editarStatus(event,data){
    console.log(data.data)
    console.log(event)

    const info = {
      method:"Update_CustomerActiveHastCredit",
      active:event.value == true ? 1:0,
      hascredit: data.data.HASCREDIT == true ? 1:0,
      customerid:parseInt(data.data.ID)
    }

    this.MapInformationService.SaveInfoSites(info)
    .subscribe(resp=>{
      if (event.value){
        this.toast.success(this.translate.instant('msgCustActSucc'))
      } else {
        this.toast.success(this.translate.instant('msgCustDeacSucc'))
      }
      this.getAlarms()
    })
  }

  // *****************************************
}
